<template>
    <div>
        <modal :show.sync="addCatalog" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar revista</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.catalog_name"
                                :error="getError('nombre')"
                                v-model="form.catalogName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   tabindex="1"
                                name="autenticación"
                                v-validate="modelValidations.auth_system"
                                :error="getError('autenticación')"
                                v-model="form.catalogPeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.catalogPeriodicity">
                            <el-option v-for="campaign in campaigns" :key="campaign.name"
                                    class="select-warning"
                                    :value="campaign.id"
                                    :label="campaign.name">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Comisión (%) *</label>
                    <fg-input   tabindex="2"
                                name="autenticación"
                                v-validate="modelValidations.auth_system"
                                :error="getError('autenticación')"
                                v-model="form.catalogRevenueId">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.catalogRevenueId">
                            <el-option v-for="revenue in revenues" :key="revenue.id"
                                    class="select-warning"
                                    :value="revenue.id"
                                    :label="revenue.value">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <br>
                <label>Ingrese los valores recibidos en las campañas</label>
                <br>
                <br>
                <div class="form-group">
                    <label>Campaña 1</label>
                    <vue-numeric  :max=999999999999999 tabindex="3" currency="$" autocomplete="off" name="campaña 1" v-validate="modelValidations.sales" :error="getError('campaña 1')" separator="." class="form-control" v-model="form.catalogCampaign1"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Campaña 2</label>
                    <vue-numeric  :max=999999999999999 tabindex="4" currency="$" autocomplete="off" name="campaña 2" v-validate="modelValidations.sales" :error="getError('campaña 2')" separator="." class="form-control" v-model="form.catalogCampaign2"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Campaña 3</label>
                    <vue-numeric  :max=999999999999999 tabindex="5" currency="$" autocomplete="off" name="campaña 3" v-validate="modelValidations.sales" :error="getError('campaña 3')" separator="." class="form-control" v-model="form.catalogCampaign3"></vue-numeric>
                </div>
                <br>
                <div class="alert alert-warning mt-2">
                    <span>Total costo mensual: {{setFormat(catalogMonthlyCostsComputed)}}</span>
                </div>
                <div class="alert alert-warning mt-2">
                    <span>Total ventas mensual: {{setFormat(catalogMonthlySalesComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddCatalog()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addCatalogToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editCatalog" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar revista</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="6"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.catalog_name"
                                :error="getError('nombre')"
                                v-model="form.catalogName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   tabindex="7"
                                name="autenticación"
                                v-validate="modelValidations.auth_system"
                                :error="getError('autenticación')"
                                v-model="form.catalogPeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.catalogPeriodicity">
                            <el-option v-for="campaign in campaigns" :key="campaign.name"
                                    class="select-warning"
                                    :value="campaign.id"
                                    :label="campaign.name">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Comisión (%) *</label>
                    <fg-input   tabindex="8"
                                name="autenticación"
                                v-validate="modelValidations.auth_system"
                                :error="getError('autenticación')"
                                v-model="form.catalogRevenueId">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.catalogRevenueId">
                            <el-option v-for="revenue in revenues" :key="revenue.id"
                                    class="select-warning"
                                    :value="revenue.id"
                                    :label="revenue.value">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <br>
                <label>Ingrese los valores recibidos en las campañas</label>
                <br>
                <br>
                <div class="form-group">
                    <label>Campaña 1</label>
                    <vue-numeric  :max=999999999999999 tabindex="9" currency="$" autocomplete="off" name="campaña 1" v-validate="modelValidations.sales" :error="getError('campaña 1')" separator="." class="form-control" v-model="form.catalogCampaign1"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Campaña 2</label>
                    <vue-numeric  :max=999999999999999 tabindex="10" currency="$" autocomplete="off" name="campaña 2" v-validate="modelValidations.sales" :error="getError('campaña 2')" separator="." class="form-control" v-model="form.catalogCampaign2"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Campaña 3</label>
                    <vue-numeric  :max=999999999999999 tabindex="11" currency="$" autocomplete="off" name="campaña 3" v-validate="modelValidations.sales" :error="getError('campaña 3')" separator="." class="form-control" v-model="form.catalogCampaign3"></vue-numeric>
                </div>
                <br>
                <div class="alert alert-warning mt-2">
                    <span>Total costo mensual: {{setFormat(catalogMonthlyCostsComputed)}}</span>
                </div>
                <div class="alert alert-warning mt-2">
                    <span>Total ventas mensual: {{setFormat(catalogMonthlySalesComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditCatalog()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editCatalogToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Ventas por catálogo</h6>
            </div>
            <div class="card-body">
                <el-table ref="catalogsTable"  highlight-current-row @current-change="handleCurrentChange" v-if="catalogs.length" :data="catalogs">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Catálogo: {{ props.row.catalogName }}</p>
                            <p>Periodicidad: {{ props.row.catalogPeriodicityName }}</p>
                            <p>Comisión: {{ props.row.catalogRevenueName }}%</p>
                            <p>Campaña 1: {{ setFormat(props.row.catalogCampaign1) }}</p>
                            <p>Campaña 2: {{ setFormat(props.row.catalogCampaign2) }}</p>
                            <p>Campaña 3: {{ setFormat(props.row.catalogCampaign3) }}</p>
                            <p>Costos: {{ setFormat(props.row.catalogMonthlyCosts) }}</p>
                            <p>Ventas: {{ setFormat(props.row.catalogMonthlySales) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Revista" property="catalogName"></el-table-column>
                    <el-table-column label="Period." property="catalogPeriodicityName"></el-table-column>
                    <!-- <el-table-column label="%" property="catalogRevenueName"></el-table-column> -->
                </el-table>
                <div>
                    <p-button 
                        @click="addCatalogMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar revista
                    </p-button>
                </div>
                <div v-if="currentRow">
                    <p-button 
                        @click="editCatalogMethod()"
                        type="default" >
                        <i class="mr-2 fa fa-pencil"></i>Editar revista
                    </p-button>
                </div>
                <div v-if="currentRow">
                    <p-button 
                        @click="removeCatalog()"
                        type="default" >
                        <i class="mr-2 fa fa-minus"></i>Quitar revista
                    </p-button>
                </div>
                <br>
                <label v-if="catalogs.length" >Últimas ventas de cada revista</label>
                <el-table v-if="catalogs.length" :data="catalogs">
                    <el-table-column label="Revista" property="catalogName"></el-table-column>
                    <el-table-column label="Ventas prom." property="catalogMonthlySalesFormat"></el-table-column>
                    <el-table-column label="Costo ventas" property="catalogMonthlyCostsFormat"></el-table-column>
                </el-table>
                <br>
                <!-- <div class="alert alert-warning mt-2">
                    <span>Total costo mensual: {{setFormat(TotalCatalogCostsComputed)}}</span>
                </div>
                <div class="alert alert-warning mt-2">
                    <span>Total ventas mensual: {{setFormat(TotalCatalogSalesComputed)}}</span>
                </div> -->
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="alert alert-success mt-2">
            <span>Total costo mensual: {{setFormat(TotalCatalogCostsComputed)}}</span>
        </div>
        <div class="alert alert-success mt-2">
            <span>Total ventas mensual: {{setFormat(TotalCatalogSalesComputed)}}</span>
        </div>
        <div class="text-right">
            <p-button  v-if="TotalCatalogSalesComputed != 0 && TotalCatalogCostsComputed != 0" @click="saveData()" type="warning">Siguiente</p-button>
            <p-button @click="toRequestData()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Table, TableColumn, Select, Option} from 'element-ui'
    import Periodicity from 'src/util/Catalogs/Periodicity'
    import Revenues from 'src/util/Catalogs/Revenues'
    import { orderBy , sortBy , find } from 'lodash';
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            pequenia_empresa: false,
            currentRow: null,
            tableData: [],
            form: {
                catalogName: '',
                catalogPeriodicity: '',
                catalogPeriodicityName: '',
                catalogRevenueId: '',
                catalogRevenue: '',
                catalogRevenueName: '',
                catalogCampaign1: '',
                catalogCampaign2: '',
                catalogCampaign3: '',
                catalogMonthlyCosts: '',
                catalogMonthlyCostsFormat: '',
                catalogMonthlySales: '',
                catalogMonthlySalesFormat: '',
            },
            addCatalog: false,
            editCatalog: false,
            catalogs: [],
            campaigns: [],
            revenues: [],
            modelValidations: {
                sales: {
                    required: false
                },
                catalog_name: {
                    required: false,
                    max: 32
                },
                average_selection: {
                    required: false
                }
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'form.catalogRevenueId': function (newVal, oldVal) {
                if (newVal != '') {
                    var revenue = this.revenues.find(revenue => revenue.id == newVal)
                    this.form.catalogRevenue = revenue.value;
                }                
            },
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            catalogMonthlyCostsComputed () {
                if (this.form.catalogPeriodicity == '' || this.form.catalogRevenue == '') {
                    return 0;
                }
                else {
                    if (this.form.catalogPeriodicity == 1) {
                        return Math.round((this.form.catalogCampaign1 + this.form.catalogCampaign2 + this.form.catalogCampaign3) / 3);
                    }
                    else if (this.form.catalogPeriodicity == 2) {
                        return this.form.catalogCampaign2 + this.form.catalogCampaign3;
                    }
                    else if (this.form.catalogPeriodicity == 3) {
                        return Math.round(((this.form.catalogCampaign1 + this.form.catalogCampaign2 + this.form.catalogCampaign3) / 60)*30);
                    }
                    else {
                        return 0
                    }
                }
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            catalogMonthlySalesComputed () {
                var sum = 0;
                if (this.form.catalogPeriodicity == '' || this.form.catalogRevenue == '') {
                    return 0;
                }
                else {
                    if (this.form.catalogPeriodicity == 1) {
                        sum = (this.form.catalogCampaign1 + this.form.catalogCampaign2 + this.form.catalogCampaign3)/3;
                        return Math.round(sum / (1 - (parseInt(this.form.catalogRevenue)/100)));
                    }
                    else if (this.form.catalogPeriodicity == 2) {
                        sum = this.form.catalogCampaign2 + this.form.catalogCampaign3;
                        return Math.round(sum / (1 - (parseInt(this.form.catalogRevenue)/100)));
                    }
                    else if (this.form.catalogPeriodicity == 3) {
                        sum = ((this.form.catalogCampaign1 + this.form.catalogCampaign2 + this.form.catalogCampaign3) / 60)*30
                        return Math.round(sum / (1 - (parseInt(this.form.catalogRevenue)/100)));
                    }
                    else {
                        return 0
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            TotalCatalogCostsComputed () {
                var sum = 0;
                for (var i=0;i<this.catalogs.length;i++) {
                    sum = sum + this.catalogs[i].catalogMonthlyCosts;
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            TotalCatalogSalesComputed () {
                var sum = 0;
                for (var i=0;i<this.catalogs.length;i++) {
                    sum = sum + this.catalogs[i].catalogMonthlySales;
                }
                return sum
            },

        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             productValidator (product) {
                if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.pequenia_empresa = true;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveData () {
                if (this.TotalCatalogCostsComputed != 0 && this.TotalCatalogSalesComputed != 0) {
                    this.$store.dispatch('setCatalogs', this.catalogs).then(()=>{
                        this.$store.dispatch('setCatalogCosts', this.TotalCatalogCostsComputed).then(()=>{
                            this.$store.dispatch('setCatalogSales', this.TotalCatalogSalesComputed).then(()=>{
                                if(this.pequenia_empresa){
                                    var vm = this;
                                    swal({
                                        title: '¿Deseas agregar información de Salarios?',
                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                        text: 'Si aceptas, podrás agregar o editar la información de los Salarios',
                                        type: 'info',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$router.push('/asessments/new_asessment/customer/others/salary');
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        if (dismiss == 'cancel') {
                                            swal({
                                                title: '¿Deseas agregar información de Obligaciones Financieras?',
                                                text: 'Si aceptas, podrás agregar o editar la información de las Obligaciones Financieras',
                                                type: 'info',
                                                showCancelButton: true,
                                                confirmButtonText: 'Si, aceptar',
                                                cancelButtonText: 'No, continuar',
                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                buttonsStyling: false
                                            }).then(() => {
                                                vm.$router.push('/asessments/new_asessment/customer/others/financial-obligations');
                                            }, function (dismiss) {
                                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                if (dismiss == 'cancel') {
                                                    vm.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                                }
                                                else {
                                                    swal({
                                                        title: 'Cancelado',
                                                        text: 'El analista no ha continuado',
                                                        type: 'error',
                                                        confirmButtonClass: 'btn btn-info btn-fill',
                                                        buttonsStyling: false
                                                    })
                                                }
                                            })
                                            
                                        }
                                        else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha continuado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            })
                                        }
                                    })
                                }
                                else {
                                    this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                }
                            }); 
                        }); 
                    });  
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addCatalogToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.form.catalogName == '' || this.form.catalogPeriodicity == '' || this.form.catalogRevenue == '' || this.form.catalogCampaign1 == 0 || this.form.catalogCampaign2 == 0 || this.form.catalogCampaign3 == 0) {
                            this.showNotificationError('Todos los campos deben estar diligenciados');
                        }
                        else {
                            var catalogPeriodicityName =  this.campaigns.filter(campaign => campaign.id == this.form.catalogPeriodicity);
                            var catalogRevenueName =  this.revenues.filter(revenue => revenue.value == this.form.catalogRevenue);
                            this.catalogs.push({
                                catalogName: this.form.catalogName,
                                catalogPeriodicity: this.form.catalogPeriodicity,
                                catalogPeriodicityName: catalogPeriodicityName[0].name,
                                catalogRevenueId: this.form.catalogRevenueId,
                                catalogRevenue: this.form.catalogRevenue,
                                catalogRevenueName: catalogRevenueName[0].value,
                                catalogCampaign1: this.form.catalogCampaign1,
                                catalogCampaign2: this.form.catalogCampaign2,
                                catalogCampaign3: this.form.catalogCampaign3,
                                catalogMonthlyCosts: this.catalogMonthlyCostsComputed,
                                catalogMonthlySales: this.catalogMonthlySalesComputed,
                                catalogMonthlyCostsFormat: this.setFormat(this.catalogMonthlyCostsComputed),
                                catalogMonthlySalesFormat: this.setFormat(this.catalogMonthlySalesComputed),
                            })
                            this.resetCatalog();
                            this.addCatalog = false;
                            this.showNotificationSuccess('Catálogo agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editCatalogToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.form.catalogName == '' || this.form.catalogPeriodicity == '' || this.form.catalogRevenue == '' || this.form.catalogCampaign1 == 0 || this.form.catalogCampaign2 == 0 || this.form.catalogCampaign3 == 0) {
                            this.showNotificationError('Todos los campos deben estar diligenciados');
                        }
                        else {
                            var catalogPeriodicityName =  this.campaigns.filter(campaign => campaign.id == this.form.catalogPeriodicity);
                            var catalogRevenueName =  this.revenues.filter(revenue => revenue.value == this.form.catalogRevenue);
                            var index = this.catalogs.indexOf(this.currentRow);
                            this.catalogs[index].catalogName= this.form.catalogName;
                            this.catalogs[index].catalogPeriodicity= this.form.catalogPeriodicity;
                            this.catalogs[index].catalogPeriodicityName= catalogPeriodicityName[0].name;
                            this.catalogs[index].catalogRevenueId= this.form.catalogRevenueId;
                            this.catalogs[index].catalogRevenue= this.form.catalogRevenue;
                            this.catalogs[index].catalogRevenueName= catalogRevenueName[0].value;
                            this.catalogs[index].catalogCampaign1= this.form.catalogCampaign1;
                            this.catalogs[index].catalogCampaign2= this.form.catalogCampaign2;
                            this.catalogs[index].catalogCampaign3= this.form.catalogCampaign3;
                            this.catalogs[index].catalogMonthlyCosts= this.catalogMonthlyCostsComputed;
                            this.catalogs[index].catalogMonthlySales= this.catalogMonthlySalesComputed;
                            this.catalogs[index].catalogMonthlyCostsFormat= this.setFormat(this.catalogMonthlyCostsComputed);
                            this.catalogs[index].catalogMonthlySalesFormat= this.setFormat(this.catalogMonthlySalesComputed);
                            this.resetCatalog();
                            this.editCatalog = false;
                            this.showNotificationSuccess('Catálogo editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeCatalog () {
                this.catalogs.splice(this.catalogs.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editCatalogMethod () {
                this.form.catalogName = this.currentRow.catalogName;
                this.form.catalogPeriodicity = this.currentRow.catalogPeriodicity;
                this.form.catalogPeriodicityName = this.currentRow.catalogPeriodicityName;
                this.form.catalogRevenueId = this.currentRow.catalogRevenueId;
                this.form.catalogRevenue = this.currentRow.catalogRevenue;
                this.form.catalogRevenueName = this.currentRow.catalogRevenueName;
                this.form.catalogCampaign1 = this.currentRow.catalogCampaign1;
                this.form.catalogCampaign2 = this.currentRow.catalogCampaign2;
                this.form.catalogCampaign3 = this.currentRow.catalogCampaign3;
                this.form.catalogMonthlyCosts = this.currentRow.catalogMonthlyCosts;
                this.form.catalogMonthlyCostsFormat = this.currentRow.catalogMonthlyCostsFormat;
                this.form.catalogMonthlySales = this.currentRow.catalogMonthlySales;
                this.form.catalogMonthlySalesFormat = this.currentRow.catalogMonthlySalesFormat;
                this.editCatalog = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetCatalog () {
                this.form.catalogName= '';
                this.form.catalogPeriodicity= '';
                this.form.catalogRevenueId= '';
                this.form.catalogRevenue= '';
                this.form.catalogCampaign1= '';
                this.form.catalogCampaign2= '';
                this.form.catalogCampaign3= '';
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addCatalogMethod () {
                this.addCatalog = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddCatalog () {
                this.addCatalog = false;
                this.resetCatalog();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditCatalog () {
                this.editCatalog = false;
                this.resetCatalog();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            dailySelectValidation () {
                if (this.checkboxes.filter(day => day.value == true).length) {
                    return false
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateSwitch () {
                if(this.switches.daily || this.switches.weekly || this.switches.monthly || this.switches.product || this.switches.average) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            }
        },
        mounted() {
            this.campaigns = Periodicity;
            for (let i=0;i<this.$store.getters.getCatalogSalePercent.length;i++) {
                this.revenues.push({
                    id: this.$store.getters.getCatalogSalePercent[i].id,
                    value: this.$store.getters.getCatalogSalePercent[i].percent
                })
                
                const myOrderedArray = _.sortBy(this.revenues, o => o.value);
                this.revenues = myOrderedArray;
            }
            if (this.$store.state.isCustomer) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)
                this.productValidator(product);   
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].catalogs != []) {
                    this.catalogs = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].catalogs;
                }
            }
            else if(this.$store.state.isSpouse) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType)
                this.productValidator(product);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].catalogs != []) {
                    this.catalogs = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].catalogs;
                }
            }
            else if (this.$store.state.isGuarantor) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType)
                this.productValidator(product);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].catalogs != []) {
                    this.catalogs = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].catalogs;
                }
            }
        }
    }
</script>
<style>
</style>
